/**
 * Tenant club vs non-club display vocabulary (`isClub` from login / feature-flags).
 * Storage codes stay MEMBER / VISITOR — this is labels only.
 */

export function parseIsClub(value, defaultValue = true) {
  if (value === undefined || value === null || value === '') return defaultValue
  if (typeof value === 'boolean') return value
  if (value === 1 || value === '1' || value === 'true' || value === 'TRUE') return true
  if (value === 0 || value === '0' || value === 'false' || value === 'FALSE') return false
  return defaultValue
}

/** UI vocabulary driven by isClub (mirrors backend tenantClubMode.patronLabels). */
export function patronLabels(isClub = true) {
  const club = parseIsClub(isClub, true)
  return {
    visitor: club ? 'Visitor' : 'Non-member',
    visitors: club ? 'Visitors' : 'Non-members',
    visitorMgmt: club ? 'Visitor Management' : 'Non-member Management',
    visitorId: club ? 'Visitor ID' : 'Non-member ID',
    patronTypeVisitor: club ? 'Visitor' : 'Non-member',
    isClub: club,
  }
}
